import * as React from 'react'
import { SVGProps } from 'react'
const SVGMenu = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={12}
    viewBox='0 0 18 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M0.297852 11.6347V10.1347H12.7978V11.6347H0.297852ZM16.6478 10.6539L11.994 6.00008L16.6478 1.34625L17.7017 2.40008L14.1017 6.00008L17.7017 9.60008L16.6478 10.6539ZM0.297852 6.75005V5.2501H9.7978V6.75005H0.297852ZM0.297852 1.86545V0.365479H12.7978V1.86545H0.297852Z'
      fill='#1C1B1F'
    />
  </svg>
)
export default SVGMenu
